/**
 * The reminder bar for leads (13 Oct 2026), on every page but Leads itself: a
 * telecaller is told the calls owed today and the new leads waiting. The owner
 * reads the same on the Leads page and is not nagged.
 */
import { Link, useLocation } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';

import { formatNumber } from '@/lib/format';
import { useLeadSummary } from './leads-api';

const plural = (n: number, one: string, many: string) => `${formatNumber(n)} ${n === 1 ? one : many}`;

export function LeadsNudge() {
  const location = useLocation();
  const summary = useLeadSummary().data;
  if (summary?.role !== 'caller' || location.pathname === '/leads') return null;
  const parts = [
    summary.due > 0 ? `${plural(summary.due, 'lead', 'leads')} to call today` : null,
    summary.pool > 0 ? `${plural(summary.pool, 'new lead', 'new leads')} waiting` : null,
  ].filter(Boolean);
  if (parts.length === 0) return null;
  return (
    <Link
      to="/leads"
      className="mb-3 flex items-center gap-3 rounded-md border border-line bg-surface-2 px-3 py-2 text-caption text-ink-2 hover:border-accent"
    >
      <PhoneCall className="h-4 w-4 shrink-0 text-accent" aria-hidden />
      <span className="min-w-0 flex-1">{parts.join(' · ')}.</span>
      <span className="shrink-0 font-medium text-accent">Open</span>
    </Link>
  );
}
